import React from 'react';
import { Outlet } from 'react-router-dom';
import useAuthStatus from '../hooks/useAuthStatus';

interface ProtectedRouteProps {
  children?: React.ReactNode;
  redirectToLogin?: boolean;
  redirectPath?: string;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({
  children,
  redirectToLogin = true,
  redirectPath = '/login'
}) => {
  const { loggedIn, loading } = useAuthStatus({
    redirectToLogin,
    redirectPath
  });

  // Show loading state while checking authentication
  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  // If not logged in, the useAuthStatus hook will handle redirection
  // But we can also provide a fallback UI if needed
  if (!loggedIn) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ minHeight: '400px' }}>
        <div className="text-center">
          <h5>請先登入</h5>
          <p>正在重新導向至登入頁面...</p>
        </div>
      </div>
    );
  }

  // If authenticated, render children or outlet
  return children ? <>{children}</> : <Outlet />;
};

export default ProtectedRoute;
